import { actionTypes } from 'actions/actionTypes'
import statusActions from 'actions/status'
import { trackCheckoutError } from 'actions/tracking'
import { validateApplePaySession as fetchValidateApplePaySession } from 'routes/Checkout/checkoutPaymentsApis'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

/**
 * Validates Apple Pay session and completes Apple Pay merchant validation.
 */
export const validateApplePaySession: CheckoutActionCreator =
  // eslint-disable-next-line no-undef
  (event: ApplePayJS.ApplePayValidateMerchantEvent, session: ApplePaySession) => async (dispatch) => {
    const { validationURL } = event
    try {
      const { data } = await fetchValidateApplePaySession(validationURL)
      session.completeMerchantValidation(data)
    } catch (e) {
      dispatch(statusActions.error(actionTypes.APPLE_PAY_MERCHANT_VALIDATION_ERROR, true))
      dispatch(
        trackCheckoutError(
          actionTypes.APPLE_PAY_MERCHANT_VALIDATION_ERROR,
          true,
          'validateApplePaySession',
        ),
      )
      session.abort()
    }
  }
